export const words = {
  place: "Lokalizacja",
  yes: "Tak",
  no: "Nie",
  new: "Nowy",
  agb: 'AGB',
  agb_full: "Ogólne warunki handlowe",
  datenschutzerklaerung: "Polityka prywatności",
  status: 'Status',
  company_name: "Nazwa firmy",
  next_button: "Dalej",
  device_name: "Nazwa urządzenia",
  to_connect: "Połącz",
  pin: 'PIN',
  time: "Czas",
  first_name: "Imię i nazwisko",
  last_name: "Nazwisko",
  code: "Kod",
  help: "Pomoc",
  total_time: "Czas całkowity",
  latitude: "Szerokość geograficzna",
  longitude: "Długość geograficzna",
  accuracy: "Dokładność",
  timestamp: "Timestamp",
  device_id: "Identyfikator urządzenia",
  active: "aktywny",
  o_clock: "Zegar",
  loading: "Sklep",
  annotation: "Uwaga",
  since: "od",
  camera: 'Kamera',
  map: "Mapa",
  gallery: "Galeria",
  work: "Praca",
  employees: "Pracownicy",
  login: "Rejestracja",
  login_action: "Zaloguj się",
  calendar_week_abbreviation: 'KW',
  calendar: "Kalendarz",
  to_call: "Zadzwoń na",
  email: "E-mail",
  attachment: "Dodatek",
  operational_planning: "Plan operacyjny",
  to_scan: "Skanuj",
  download: "Pobierz",
  export: "Eksport",
  to_document: "Dokument",
  checklist: "Lista kontrolna",
  checklists: "Listy kontrolne",
  password: "Hasło",
  confirmation: "Potwierdzenie",
  confirm: "Potwierdzenie",
  confirmation_email: "E-mail potwierdzający",
  unknown: "Nieznany",
  unknown_place: "Nieznana lokalizacja",
  unknown_plan: "Nieokreślony harmonogram zmian",
  project_no: "Projekt nr.",
  project_file: "Akta projektu",
  contact_person: "Kontakt",
  overtime: "Nadgodziny",
  timesheet: "Harmonogram",
  minustime: "Godziny minusowe",
  back: "Powrót",
  undo: "Undo",
  clockout: "Wytłoczyć",
  clocked_out: "wytłoczony",
  clockin: "Pieczęć w",
  clocked_in: "wytłoczony",
  dismiss: "Anuluj",
  discard: "Odrzucać",
  finish: "Gotowe",
  or: "lub",
  copy: "Kopiować",
  qr_code: "kod QR",
  documentation: "Rejestracja i dokumentacja czasu pracy",
  attendance: "Terminal tabletów",
  tiercontent: "Zakres opakowania",
  start_now: "Zacznij teraz",
  skip: "skip",
  logout_during_core_time: "Stemplowane w czasie podstawowym",
  absent_during_core_time: "Nieobecny w czasie rdzenia",
  distance: "Odległość",
  km_reading: "Przebieg",
  the_start: 'Start',
  the_end: "Koniec",
  license_plate: "Tablica rejestracyjna",
  details: "szczegóły",
  hide: "ukrycie",
  cost: "Koszty",
  file: "Plik",
  address_book: "Książka adresowa",
  template_plural: "Szablony",
  signature: "Podpis",
  main_project: "Główny projekt",
  main_projects: "Główne projekty",
  sub_projects: "Podprojekty",
  scan_to_login_header: "Rejestracja za pomocą kodu QR",
  description: "Opis",
  project_location: "Lokalizacja projektu",
  phone_number: "Numer telefonu",
  project_info: "Informacje o projekcie",
  number_short: "Nie.",
  sketch: "Szkic",
  video: "Wideo",
  delete: "Usuń",
  send: "Wyślij",
  sending: "Wyślij...",
  save: "Zapisz",
  granted: "zatwierdzony",
  pending: "wymagane",
  denied: "Odrzucony",
  customer: "Klient",
  mobile_number: "Numer telefonu",
  ok: 'Ok',
  day: "Dzień",
  tomorrow: "Rano",
  days: "Dni | Dzień | Dni",
  holidays: "Wakacje",
  vacation_days: "Wakacje",
  vacation_hours: "Godziny urlopu",
  request: "Wniosek",
  accept: "Akceptuj",
  withdraw: "Wycofać",
  hour_account: "Rachunek godzinowy",
  period: "Okres",
  to: "do",
  date: "Powołanie",
  number: "Numer",
  message: "Wiadomość",
  change: "zmiana",
  changed: "Zmienione",
  changed_fields: "Zmienione pola",
  type: "Art.",
  hour: "Godzina",
  hours: "Godziny",
  hours_abbreviation: 'Std.',
  hours_with_amount: "{amount} Godziny",
  end: "koniec",
  end_date: "Termin",
  start_date: "Data rozpoczęcia",
  absence: "Nieobecność",
  month: "miesiąc",
  week: "Tydzień",
  transcript: "Transkrypcja",
  time_left: "pozostały",
  transcript_tasks: "Zadania",
  add_task: "Nowy",
  /** Differentiation in some languages (e.g. English) */
  from: "z",
  of: "z",
  of_hours: "od {hours} godz.",
  of_hours_abbreviation: "{hours} od godz.",
  /**************/

  used: "używany",
  update: "Aktualizacja",
  today: "dziś",
  correction: "Korekta",
  work_time: "Czas pracy",
  break: "Przerwa",
  loading_time: "Czas załadunku",
  driving_time: "Czas podróży",
  business_trip: "Tour of duty",
  project: 'Projekt',
  special_one: "Specjalne1",
  special_two: "Specjalne2",
  clock: "Zegar",
  search: "Szukaj",
  operation: "Działalność",
  day_protocol: "Protokół dzienny",
  continue: "więcej",
  total_duration: "Czas całkowity",
  duration: "Czas trwania",
  hello: "Witam",
  close: "zamknąć",
  comment: "Komentarz",
  small: "mała",
  medium: "średni",
  large: "duży",
  sharpie: "Pin",
  line: "Linia",
  arrow: "Strzałka",
  rectangle: "Prostokąt",
  ellipse: "Elipsa",
  text: "Tekst",
  language_settings: "Ustawienia języka",
  clock_reminder: "Przypomnienie o znaczku",
  individually: "Osobnik",
  from_o_clock: "z",
  to_o_clock: "do",
  eraser: "Gumka",
  edit: "Edytuj",
  legal_notes: "Prawna",
  notes: "Uwagi",
  note: "Uwaga",
  imprint: "Nadruk",
  open_source_licenses: "Warunki licencji Open Source",
  author: 'Autor',
  license_type: "Rodzaj licencji",
  version: "Wersja",
  substitute: "Reprezentacja",
  not_rated: "Brak oceny",
  weekly_working_hours: "Tygodniowy czas pracy",
  show_less: "Pokaż mniej",
  office_center: "Centrum biurowe",
  admin_view: "Zarządzanie NFC",
  register: "Rejestr",
  shifts: {
    shift_attachments: "Dodatki (warstwa)",
    shift_plan_attachments: "Dodatki (plan zmian)",
    shift_plan: "Grafik zmian",
    shift: "Warstwa"
  },
  absences: {
    sick: "Choroba (kontynuacja wypłaty wynagrodzenia)",
    vacation: "Wakacje",
    workshop: "Seminarium/Kurs",
    special_vacation: "Urlop specjalny",
    school: "Szkoła",
    working_time_account: "Konto czasu pracy",
    holiday: "Wakacje",
    other: "Inne",
    driving_time: "Czas podróży",
    parental_leave: "Urlop rodzicielski",
    excused_absent: "Nieobecność usprawiedliwiona (płatna)",
    not_excused_absent: "Nieobecność nieusprawiedliwiona",
    sick_industrial_accident: "Choroba Wypadek przy pracy (LFZ)",
    short_time_work: "Praca krótkoterminowa (Kug)",
    maternity_pay: "Wynagrodzenie za ochronę macierzyństwa/zakaz pracy",
    sick_child: "Opieka nad chorym dzieckiem z wynagrodzeniem chorobowym (dziennym)",
    sick_child_no_payment: "Opieka nad chorym dzieckiem bez wynagrodzenia chorobowego (dziennego)",
    vacation_no_payment: "Urlop bezpłatny",
    sick_before_short_time_work: "Zasiłek chorobowy/choroba przed Kuguarem",
    weather_related_failure: "Niepowodzenie z powodu warunków pogodowych",
    sick_short_time_work: "Choroba w czasie Kugu",
    sick_no_payment: "Choroba (bez ciągłego wypłacania wynagrodzenia)",
    company_vacation: "Urlop firmowy",
    meals_14_euro: "Niewielki dodatek gastronomiczny",
    meals_28_euro: "Duży dodatek na wyżywienie"
  },
  image_editor: {
    font_size: "Wielkość czcionki",
    stroke_width: "Szerokość linii",
    stroke_color: "Kolor linii",
    text_color: "Kolor czcionki",
    rotate_left: "Skręć w lewo",
    rotate_right: "Skręć w prawo",
    flip_horizontal: "Lustro poziomo",
    flip_vertical: "Lustro pionowo"
  },
  travel_log: {
    method_of_transportation: "Środki transportu",
    company_car: "Samochód służbowy",
    private_car: "Samochód prywatny",
    rental_car: "Wypożyczony samochód",
    taxi: "Taksówka",
    public_transportation: "Transport publiczny",
    airplane: "Samolot",
    train: "Kolej (dalekobieżny transport publiczny)",
    other: "Inne",
    km_reading_start: "Przebieg początkowy",
    km_reading_end: "Przebieg końcowy",
    net_expenses: "Koszty podróży (netto)",
    tax: "Podatek od wartości dodanej"
  },
  read_in: "Czytaj w",
  currency: "Waluta",
  reason: "Powód",
  label: "Etykieta",
  monday: "Poniedziałek",
  tuesday: "Wtorek",
  wednesday: "Środa",
  thursday: "Czwartek",
  friday: "Piątek",
  saturday: "Sobota",
  sunday: "Niedziela",
  break_alarm: "Przerwij budzik",
  clockin_reminder: "Przypomnienie o rejestracji",
  clockout_reminder: "Przypomnienie o wypisaniu"
};